module.exports = __webpack_public_path__ + "assets/img/Small.179e7451.svg";